module.exports = __webpack_public_path__ + "static/img/congrats.ef412a62.png";